/** Módulo /tarjetas_credito — sincronizar con server_admin y smart_back */
export const TARJETAS_CREDITO_MODULE_ID = 'tarjetas_credito'

const STAFF_ROLES = ['ADMIN', 'COLABORADOR', 'SUPER_COLABORADOR']

export function hasInternalTeamRole(roles) {
  return (roles || []).some((r) => STAFF_ROLES.includes(r))
}

export function defaultTarjetasCreditoAccess(roles) {
  return hasInternalTeamRole(roles)
}

function findModulePermission(permissions, moduleId) {
  const direct = permissions?.find((p) => p.moduleId === moduleId)
  if (direct?.hasAccess === true || direct?.hasAccess === false) return direct
  return direct
}

/**
 * Jerarquía: bloqueo empresa → usuario×empresa → usuario → default por rol staff.
 */
export function resolveTarjetasCreditoAccess(
  userPerm,
  companyPerm,
  userCompanyPerm,
  roles,
) {
  const companyRow = findModulePermission(
    companyPerm ? [companyPerm] : undefined,
    TARJETAS_CREDITO_MODULE_ID,
  )
  if (companyRow?.hasAccess === false) return false

  const userCompanyRow = findModulePermission(
    userCompanyPerm ? [userCompanyPerm] : undefined,
    TARJETAS_CREDITO_MODULE_ID,
  )
  if (userCompanyRow?.hasAccess === true) return true
  if (userCompanyRow?.hasAccess === false) return false

  const userRow = findModulePermission(
    userPerm ? [userPerm] : undefined,
    TARJETAS_CREDITO_MODULE_ID,
  )
  if (userRow?.hasAccess === true) return true
  if (userRow?.hasAccess === false) return false

  return defaultTarjetasCreditoAccess(roles)
}
